import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import {withStyles} from "@material-ui/core";


import LinearProgress from "@material-ui/core/LinearProgress";


const CustomerLinearProgress = withStyles({
    colorSecondary: "var(--accent)",
    colorPrimary: "var(--company)"
})(LinearProgress);


function LinearLoadingIndicator(props) {
    return (
        <CustomerLinearProgress />
    );
}

LinearLoadingIndicator.propTypes = {};
LinearLoadingIndicator.defaultProps = {};

export default LinearLoadingIndicator;
